export type RouteAccess = 'public' | 'protected' | 'unclassified';

export const AUTH_ROUTE_ACCESS: { registration: RouteAccess } = {
  registration: 'unclassified',
};